import { DateTime, DateTimeFormatOptions } from 'luxon';

import { ConsumablesOrderStatus } from 'shared';

export function getConsumablesOrderProgressPercent(status: ConsumablesOrderStatus | string) {
  const byStatus: Record<ConsumablesOrderStatus, number> = {
    open: 10,
    locked: 50,
    delivered: 90,
    canceled: 90
  };
  return byStatus[status as ConsumablesOrderStatus] ?? 10;
}

export function formatDeliveryDate({
  date,
  format,
  status
}: {
  date?: string | DateTime | null;
  format?: DateTimeFormatOptions;
  status?: ConsumablesOrderStatus;
}) {
  if (!date) return '';

  const dateTime = date instanceof DateTime ? date : DateTime.fromISO(date);
  const deliveryDay = dateTime.startOf('day');
  const today = DateTime.now().startOf('day');
  const inThePast = deliveryDay.toMillis() < today.toMillis();
  const dateWord = getRelativeDateWord(dateTime) || dateTime.toLocaleString(format);

  return `${inThePast || status === 'delivered' ? 'Arrived' : 'Arriving'} ${dateWord}`;
}

export function getRelativeDateWord(date?: string | DateTime | null) {
  if (!date) return '';

  const dateTime = date instanceof DateTime ? date : DateTime.fromISO(date);
  const dateIsToday = dateTime.startOf('day').equals(DateTime.now().startOf('day'));
  const dateIsTomorrow = dateTime.startOf('day').equals(DateTime.now().plus({ day: 1 }).startOf('day'));
  const dateIsYesterday = dateTime.startOf('day').equals(DateTime.now().minus({ day: 1 }).startOf('day'));

  return dateIsToday ? 'today' : dateIsTomorrow ? 'tomorrow' : dateIsYesterday ? 'yesterday' : '';
}
